/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../common.js';
import type { StakingBridge, StakingBridgeInterface } from '../StakingBridge.js';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_rollupProcessor',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'ApproveFailed',
    type: 'error',
  },
  {
    inputs: [],
    name: 'AsyncDisabled',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidCaller',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidInput',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MissingImplementation',
    type: 'error',
  },
  {
    inputs: [],
    name: 'SwapFailed',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    stateMutability: 'payable',
    type: 'fallback',
  },
  {
    inputs: [],
    name: 'LQTY',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'LUSD',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ROLLUP_PROCESSOR',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'STAKING_CONTRACT',
    outputs: [
      {
        internalType: 'contract ILQTYStaking',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'SUBSIDY',
    outputs: [
      {
        internalType: 'contract ISubsidy',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'UNI_ROUTER',
    outputs: [
      {
        internalType: 'contract ISwapRouter',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'USDC',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'WETH',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'computeCriteria',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_inputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_outputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '_totalInputValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '_auxData',
        type: 'uint64',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'convert',
    outputs: [
      {
        internalType: 'uint256',
        name: 'outputValueA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'subtractedValue',
        type: 'uint256',
      },
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'finalise',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'addedValue',
        type: 'uint256',
      },
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'setApprovals',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
];

const _bytecode =
  '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';

type StakingBridgeConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: StakingBridgeConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class StakingBridge__factory extends ContractFactory {
  constructor(...args: StakingBridgeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _rollupProcessor: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<StakingBridge> {
    return super.deploy(_rollupProcessor, overrides || {}) as Promise<StakingBridge>;
  }
  override getDeployTransaction(
    _rollupProcessor: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_rollupProcessor, overrides || {});
  }
  override attach(address: string): StakingBridge {
    return super.attach(address) as StakingBridge;
  }
  override connect(signer: Signer): StakingBridge__factory {
    return super.connect(signer) as StakingBridge__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingBridgeInterface {
    return new utils.Interface(_abi) as StakingBridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): StakingBridge {
    return new Contract(address, _abi, signerOrProvider) as StakingBridge;
  }
}
